<template>
  <div>
    <settlement-list v-if="$route.name === 'settlement-list'"></settlement-list>
    <router-view v-else></router-view>
  </div>
</template>

<script setup lang="ts">
import SettlementList from './SettlementList.vue'

defineOptions({
  name: 'SettlementIndex',
})
</script>
